import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../../APIHelpers/Responses";

export const categoryServices = {
  addNewBlogCategory,
  updatedBlogCategory,
  softDeleteRestoreBlogCategory,
  deleteBlogCategory,
  getBlogCategoryList,
};

// Add New Bank Meta
async function addNewBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewBlogCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Bank Meta
async function updatedBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedBlogCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Bank Meta
async function softDeleteRestoreBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreBlogCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Bank Meta
async function deleteBlogCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteBlogCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Bank Meta
async function getBlogCategoryList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getBlogCategoryList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getBlogCategoryList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}